/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Pack_BodyInputs */

const en_price_page_pack_body = /** @type {(inputs: Price_Page_Pack_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy a pack once, and every visit takes one entry off it. You always see how many are left.`)
};

const pl_price_page_pack_body = /** @type {(inputs: Price_Page_Pack_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kupujesz pakiet raz, a każda wizyta odejmuje jedno wejście. Zawsze widzisz, ile zostało.`)
};

/**
* | output |
* | --- |
* | "Buy a pack once, and every visit takes one entry off it. You always see how many are left." |
*
* @param {Price_Page_Pack_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_pack_body = /** @type {((inputs?: Price_Page_Pack_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Pack_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_pack_body(inputs)
	return en_price_page_pack_body(inputs)
});